import n from '../../../../../../../external/rollup-plugin-styles/dist/runtime/inject-css.js';
var css = ".monaco-editor .lines-content .cdr{height:100%;position:absolute}";
n(css,{});
export { css, css as default };
